/* No third-party scripts, tracking cookies, or payment code. Shopify owns checkout. */
(() => {
  'use strict';
  const getDialogs = () => [...document.querySelectorAll('[data-piece-dialog]')];

  function updateTags(form) {
    const tags = form.querySelector('[data-signup-tags]');
    if (!tags) return;
    const values = ['newsletter', 'plate-theory', 'drop-001'];
    const piece = form.querySelector('[data-piece-select]')?.value;
    const size = form.querySelector('[data-size-select]')?.value;
    if (piece) values.push(`pt-design:${piece}`);
    if (size) values.push(`pt-size:${size}`);
    tags.value = values.join(',');
  }

  function selectPiece(code) {
    document.querySelectorAll('[data-piece-select]').forEach(select => {
      if ([...select.options].some(option => option.value === code)) select.value = code;
      if (select.form) updateTags(select.form);
    });
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }

  function openPiece(code, trigger, updateUrl = true) {
    const dialog = getDialogs().find(item => item.dataset.pieceDialog === code);
    selectPiece(code);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    getDialogs().forEach(item => closeDialog(item));
    dialog.showModal();
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('piece', code);
      url.hash = 'the-drop';
      history.replaceState(null, '', url);
    }
    return true;
  }

  function setup(root = document) {
    root.querySelectorAll('[data-preference-fields]').forEach(element => { element.hidden = false; });
    root.querySelectorAll('.early-form').forEach(form => {
      updateTags(form);
      if (form.dataset.ptReady) return;
      form.dataset.ptReady = 'true';
      form.addEventListener('change', () => updateTags(form));
      // Native POST to Shopify: no localStorage or simulated success state.
      form.addEventListener('submit', () => updateTags(form));
    });
    root.querySelectorAll('[data-piece-dialog]').forEach(dialog => {
      if (dialog.dataset.ptReady) return;
      dialog.dataset.ptReady = 'true';
      dialog.addEventListener('click', event => { if (event.target === dialog) closeDialog(dialog); });
    });
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.ptReady) return;
      select.dataset.ptReady = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const summary = select.closest('.product-summary');
        const price = summary?.querySelector('[data-variant-price]');
        const button = select.form?.querySelector('[data-add-to-cart]');
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
        if (button) {
          button.disabled = !option || option.disabled;
          button.textContent = button.disabled ? 'Sold out' : 'Add to bag';
        }
      });
    });
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const preview = event.target.closest('[data-open-piece]');
    if (preview && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      if (openPiece(preview.dataset.openPiece, preview)) event.preventDefault();
    }
    const close = event.target.closest('[data-close-dialog]');
    if (close) closeDialog(close.closest('dialog'));
    const waitlist = event.target.closest('[data-waitlist-piece]');
    if (waitlist) {
      selectPiece(waitlist.dataset.waitlistPiece);
      getDialogs().forEach(dialog => closeDialog(dialog));
      const url = new URL(window.location.href);
      url.searchParams.set('piece', waitlist.dataset.waitlistPiece);
      url.hash = 'early-access';
      history.replaceState(null, '', url);
      document.querySelector('#early-access')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      document.querySelector('.early-form input[type=email]')?.focus({ preventScroll: true });
    }
    if (event.target.closest('.mobile-nav nav a')) document.querySelector('.mobile-nav')?.removeAttribute('open');
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelector('.mobile-nav')?.removeAttribute('open');
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  setup();
  const code = new URL(window.location.href).searchParams.get('piece');
  if (code) {
    selectPiece(code);
    if (window.location.hash !== '#early-access') openPiece(code, null, false);
  }
  document.querySelector('[data-form-result]')?.focus({ preventScroll: false });
})();
